import { typeRampDefinitions } from "./constants/deprecatedTypeRampConstants";
import { fontSizeDefinitions } from "./constants/lodestarConstants";
import { fontWeight, fontFamily } from "./constants/typographyConstants";
export const typography = {
  fontSizeDefinitions,
  fontWeight,
  fontFamily,
  typeRampDefinitions
};
export { TypeRamp } from "./components/TypeRamp";
export { TypeRampV2 } from "./components/TypeRampV2";
export { ursaSemanticTypeRampDefinitions, ursaTypeRampDefinitions } from "./constants/ursaConstants";
//# sourceMappingURL=index.js.map